import { LessonPlanLocale } from "@/locales/localeid";
import { EmptyGuid } from "@/util/constants";
import { fmtMsg } from "commonui";

export interface ILessonPlanVersionModel {
	id?: string;
	versionGroupId?: string;
	versionGroupName?: string;
	versionGroupType?: number;
	methodology?: number;
	name?: string;
	description?: string;
	status?: number;
}

export interface IContentConversationRepModel {
	contentId: string;
	contentName: string;
	conversationId: number;
	conversationName: string;
	unit: number;
	unitId: number;
	curriculumType: number;
}

export const EmptyRepConversation: IContentConversationRepModel = {
	contentId: EmptyGuid,
	contentName: "",
	conversationId: 0,
	conversationName: fmtMsg(LessonPlanLocale.LessonPlanMasterPlanManageConversationCustomTitle),
	unit: 0,
	unitId: 0,
	curriculumType: 0
};

export enum LessonPlanVersionColumns {
	Id = "id",
	VersionGroupIdColumn = "versionGroupId",
	VersionGroupNameColumn = "versionGroupName",
	VersionNameColumn = "name",
	MethodologyColumn = "methodology",
	MethodologyTextColumn = "methodologyText",
	DescriptionColumn = "description",
	StatusColumn = "status",
	StatusTextColumn = "statusText",
	ActionColumn = "action"
}

export interface ILessonPlanListModel {
	id?: string;
	name?: string;
	sequence?: number;
	estimatedTime?: number;
	estimatedTime4Minute?: string;
	lessonPlanVersionId?: string;
	unitId?: number;
	exposureCount?: number;
	conversationCount?: number;
	conversationSpeed?: number;
}

export interface ILessonPlanModel {
	id?: string;
	name?: string;
	sequence?: number;
	lessonPlanVersionId?: string;
	unitId?: number;
	lessonPlanItem: ILessonPlanItemModel[];
}

export interface ILessonPlanItemModel {
	id?: string;
	lessonPlanId?: string;
	componentId?: string;
	sequence?: number;
	type?: number;
	contentExposure?: any;
	transition?: any;
	optionalContent?: any;
	text?: string;
	contentConversation?: IContentConversationModel;
}

export interface IContentConversationModel {
	contentId: string;
	contentName: string;
	description: string;
	statusId: number;
	isPublished: boolean;
	isComplete: boolean;
	conversationName: string;
}

export enum LessonPlanListColumns {
	Id = "id",
	NameColumn = "name",
	SequenceColumn = "sequence",
	EstimatedTimeColumn = "estimatedTime",
	EstimatedTime4MinuteColumn = "estimatedTime4Minute",
	ExposureCount = "exposureCount",
	ExposureConversation = "exposureConversation",
	ActionColumn = "action"
}

export function sortLessonPlanVersions(versionA: ILessonPlanVersionModel, versionB: ILessonPlanVersionModel): number {
	const vergionGroupTypeA: number | undefined = versionA.versionGroupType;
	const vergionGroupTypeB: number | undefined = versionB.versionGroupType;
	const statusA: number = versionA.status as number;
	const statusB: number = versionB.status as number;
	const methodologyA: number = versionA.methodology as number;
	const methodologyB: number = versionB.methodology as number;
	const nameA: string = versionA.name as string;
	const nameB: string = versionB.name as string;
	return vergionGroupTypeA !== vergionGroupTypeB
		? (vergionGroupTypeA as number) - (vergionGroupTypeB as number)
		: statusA !== statusB
		? statusA - statusB
		: methodologyA !== methodologyB
		? methodologyA - methodologyB
		: nameA.localeCompare(nameB);
}

export interface ILessonPlanTemplateModel {
	id?: string;
	name?: string;
	default?: boolean;
	headerRowRange?: string;
	teachingPlanRowRange?: string;
	transitionRowRange?: string;
	templateFileName?: string;
	templateFile?: File;
	methodology?: number;
}

export enum LessonPlanTemplateColumns {
	Id = "id",
	NameColumn = "name",
	DefaultColumn = "default",
	MethodologyColumn = "methodology",
	MethodologyText = "methodologyText",
	DeleteColumn = "delete",
	TemplateFileName = "templateFileName",
	TemplateFile = "templateFile",
	HeaderRowRange = "headerRowRange",
	TeachingPlanRowRange = "teachingPlanRowRange",
	TransitionRowRange = "transitionRowRange"
}

export interface ILessonPlanVersionSimpleModel {
	id: string;
	versionGroupId: string;
	name: string;
	description: string;
	methodology: number;
	status: number;
	combinedNameMethodology: string;
}
